export enum ModuleName {
    None = 0,
    NewsAndAdvice = 0x1,
    Agrometeorology = 0x2,
    AgroclimateStations = 0x4,
    PlantProtection = 0x8,
    Communication = 0x10,
    RecordsAndEducations = 0x20,
    Records = 0x40,
    Education = 0x80,
    Administration = 0x100,
    UserAdministration = 0x200,
    UserActivity = 0x400,
    ModulesAdministration = 0x800,
    SystemAdministration = 0x1000,
    SemisAdministrationModule = 0x2000,
    Codebook = 0x4000,
    PhytoViewAdministration = 0x8000,
    InternalSystemsModule = 0x10000,
    ExternalModules = 0x20000,
    EducationAnalysis = 0x40000,
    SEMIS = 0x80000,
    Sharepoint = 0x100000,
    Intranet = 0x200000,
    ITSupport = 0x400000,
    WebAuthors = 0x800000,
    PioForRespondents = 0x1000000,
    Agronet = 0x2000000,
    Vetis = 0x4000000,
    EducationDocuments = 0x8000000,
    UserProfile = 0x10000000,
    Beekeeping = 0x20000000,
    MobileAppPortal = 0x40000000,
    UserNotifications = 0x80000000,
    ActiveDirectoryUsers = 0x100000000,
    AgroSensorics = 0x200000000,
    InteractiveMap = 0x400000000,
    MySensorics = 0x800000000
}

export const moduleNames: Record<string, { value: number; label: string }> = {
    NewsAndAdvice: {
        value: ModuleName.NewsAndAdvice,
        label: "Vijesti i savjeti",
    },
    Agrometeorology: {
        value: ModuleName.Agrometeorology,
        label: "Agrometeorologija",
    },
    AgroclimateStations: {
        value: ModuleName.AgroclimateStations,
        label: "Agroklimatske stanice",
    },
    PlantProtection: {
        value: ModuleName.PlantProtection,
        label: "Zaštita bilja",
    },
    Communication: {
        value: ModuleName.Communication,
        label: "Komunikacija",
    },
    RecordsAndEducations: {
        value: ModuleName.RecordsAndEducations,
        label: "Evidencije i edukacije",
    },
    Records: {
        value: ModuleName.Records,
        label: "Evidencije",
    },
    Education: {
        value: ModuleName.Education,
        label: "Tečajevi",
    },
    Administration: {
        value: ModuleName.Administration,
        label: "Administracija",
    },
    UserAdministration: {
        value: ModuleName.UserAdministration,
        label: "Korisnici",
    },
    ActiveDirectoryUsers: {
        value: ModuleName.ActiveDirectoryUsers,
        label: "AD Korisnici",
    },
    UserActivity: {
        value: ModuleName.UserActivity,
        label: "Aktivnost korisnika",
    },
    ModulesAdministration: {
        value: ModuleName.ModulesAdministration,
        label: "Dodatni moduli",
    },
    SystemAdministration: {
        value: ModuleName.SystemAdministration,
        label: "Informacije o sustavu",
    },
    SemisAdministrationModule: {
        value: ModuleName.SemisAdministrationModule,
        label: "Administracija PG-ova",
    },
    Codebook: {
        value: ModuleName.Codebook,
        label: "Šifrarnik",
    },
    PhytoViewAdministration: {
        value: ModuleName.PhytoViewAdministration,
        label: "PhytoView Administracija",
    },
    MobileAppPortal: {
        value: ModuleName.MobileAppPortal,
        label: "Portal Mobilnih aplikacija",
    },
    InternalSystemsModule: {
        value: ModuleName.InternalSystemsModule,
        label: "Interni sustavi",
    },
    ExternalModules: {
        value: ModuleName.ExternalModules,
        label: "Dodatni moduli",
    },
    EducationAnalysis: {
        value: ModuleName.EducationAnalysis,
        label: "Analiza edukacija",
    },
    SEMIS: {
        value: ModuleName.SEMIS,
        label: "SEMIS",
    },
    Sharepoint: {
        value: ModuleName.Sharepoint,
        label: "Sharepoint",
    },
    Intranet: {
        value: ModuleName.Intranet,
        label: "Intranet",
    },
    ITSupport: {
        value: ModuleName.ITSupport,
        label: "IT podrška",
    },
    WebAuthors: {
        value: ModuleName.WebAuthors,
        label: "Web autori",
    },
    PioForRespondents: {
        value: ModuleName.PioForRespondents,
        label: "PIO za odgovarače",
    },
    Agronet: {
        value: ModuleName.Agronet,
        label: "Agronet",
    },
    Vetis: {
        value: ModuleName.Vetis,
        label: "Vetis",
    },
    EducationDocuments: {
        value: ModuleName.EducationDocuments,
        label: "Dokumentacija",
    },
    UserProfile: {
        value: ModuleName.UserProfile,
        label: "Moj profil",
    },
    Beekeeping: {
        value: ModuleName.Beekeeping,
        label: "Moje pčelarstvo",
    },
    UserNotifications: {
        value: ModuleName.UserNotifications,
        label: "Moje poruke",
    },
    Agrosenzorika: {
        value: ModuleName.AgroSensorics,
        label: "Agrosenzorika",
    },
    InteractiveMap: {
        value: ModuleName.InteractiveMap,
        label: "Interaktivna karta",
    },
    MySensorics: {
        value: ModuleName.MySensorics,
        label: "Moja senzorika",
    },
};
